import { useState ,  useEffect } from "react";
import SearchIcon from "assets/icons/fi-rr-search.svg";
import ExcelIcon from "assets/icons/xlsx-file-format-extension-1.svg";
import styles from "./style.module.scss";
import "antd/dist/antd.css";
import { DatePicker } from "antd";
import "moment/locale/tr";
import locale from "antd/es/date-picker/locale/tr_TR";
import { HourlyConsumptionModelResponse } from "types";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import type { DatePickerProps } from "antd";
import ReactPaginate from "react-paginate";
import NextIcon from "assets/icons/pagination-next.svg";
import PrevIcon from "assets/icons/pagination-prev.svg";
import "../../../pages/sayacVerileri/paginate.css";
import LoaderSpinner from "../../UI/LoaderSpinner/LoaderSpinner";
import { locationController } from "utils/locationhelper";
import AuthService from "../../../services/AuthService";

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify'

const { RangePicker } = DatePicker;
const TesisatDetaylariOSF = () => {
  const params = useParams<any>();
  const { keycloak } = useKeycloak();
  const [showDetail, setShowDetail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [monthValue, setMonthValue] = useState(0);
  const [yearValue, setYearValue] = useState(0);
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(24);
  const [hourlyConsumptionList, setHourlyConsumption] = useState<HourlyConsumptionModelResponse| []>(null!);
  const customFormat: DatePickerProps["format"] = (value) =>
    `${value.localeData().months(value)} ${value.year()} `;

    const auth = new AuthService(keycloak);

    let companyId = locationController();


  const getOsf = async() => {
    setIsLoading(true);
    
    auth.axios(`/HourlyConsumption/ReadHourlyListData`, null, {
      tesisatNo: params.id,
      email: keycloak?.tokenParsed?.email,
      companyId : companyId,
      month: monthValue,
      year: yearValue
    }).then(response => {
      setIsLoading(false);
      if (response.data.success === true) {
        setHourlyConsumption(response.data.data)
        // Fetch items from another resources.
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(response.data.data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(response.data.data.length / itemsPerPage));
      }
      else {

        if (response.data.message) {
          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
          });
        }   
          
      }

    }).catch(err => {
      setIsLoading(false);

      toast.error(err.response.data.message, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
      });

    });

  }

  useEffect(() => {
    if(yearValue!==0 && monthValue!==0)
      getOsf()
  
  }, []);

  const handlePageClick = async(event: any) => {
    var newOffset = ((event.selected) * itemsPerPage) % hourlyConsumptionList.length;
    await setItemOffset(newOffset);
    var endOffset = newOffset + itemsPerPage;
    setCurrentItems(hourlyConsumptionList.slice(newOffset, endOffset));

  };
  
  const handleExportCustomExcel = async() => {

    var response =  await auth.axios(`/HourlyConsumption/ExcelExport`, null, {
      tesisatNo: params.id,
      email: keycloak?.tokenParsed?.email,
      companyId : companyId,
      month: monthValue,
      year: yearValue
    })

    const base64Excel = "data:application/vnd.ms-excel;base64,"+ response.data.fileContents;

    const outputFilename = response.data.fileDownloadName;

    const link = document.createElement('a');
    link.download = outputFilename;
    link.href = base64Excel;
    document.body.appendChild(link);
    link.click();
  }

  return (
    <div>
      <ToastContainer/>
      <div className={styles.osf}>
        <div className={styles.headerCard}>
          <div className={styles.card}>
            <div>Tarih</div>
            <div className={styles.rangePicker}>
              <DatePicker
                placeholder={"Tarih Seçiniz"}
                suffixIcon={false}
                locale={locale}
                bordered={false}
                format={customFormat}
                picker="month"
                onChange={(date:any) => {
                  setMonthValue(date?.month()+1)
                  setYearValue(date?.year())
                }}
              />
            </div>
            <img
              onClick={() => {
                getOsf();
              }}
              src={SearchIcon}
              alt=""
            />
          </div>
          <div
            onClick={() => {
              handleExportCustomExcel();
            }}
            className={styles.excel}
          >
            <img src={ExcelIcon} alt="" />
            <div>Excel'e aktar</div>
          </div>
        </div>
        <div className={styles.detailTable}>
          <div className={styles.tableHeader}>
            <div>Tarih</div>
            <div>Üretim</div>
            <div>Tüketim</div>
          </div>
          <div className={styles.hr}></div>
          {isLoading ? <LoaderSpinner /> : 
            currentItems?.map((data, idx) => (
              <div key={idx}>
                <div className={styles.tableRow}>
                  <div>{data.timeStamp}</div>
                  <div>{data.generation}</div>
                  <div>{data.consumption}</div>
                </div>
                <div className={styles.hr}></div>
              </div>
            ))    
          }
        </div>
        <div className="pagination-container">
          <ReactPaginate
            breakLabel="..."
            nextLabel={<img src={NextIcon} alt="icon" />}
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel={<img src={PrevIcon} alt="icon" />}
            className="pagination"
            activeClassName="pagination-active-item"
            containerClassName="pagination-container"
            pageClassName="pagination-item"
            previousClassName="pagination-item-previous"
            nextClassName="pagination-item-next"
            breakClassName="pagination-item-break"
          />
        </div>
      </div>
    </div>
  );
};

export default TesisatDetaylariOSF;
